<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Buttons'
 * Name: 'Primary'
 * FIGMA:'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=3449-3935&t=ldymHtYK0zJDKBqF-4'
 */
import type { BtnPrimaryProps } from '@UI/Buttons/BtnPrimary/types/interfaces'

import { useBtnPrimary } from '@UI/Buttons/BtnPrimary/composables/use-btn-primary.hook'
import { IconContainer } from '@UI/Other/IconContainer'

import { NuxtLink } from '#components'

defineOptions({
  name: 'BtnPrimary',
})

withDefaults(defineProps<BtnPrimaryProps>(), {
  title: '',
  color: 'blue',
  disabled: false,
  elementWidth: 'auto',
  to: undefined,
})

const emit = defineEmits<{
  click: []
}>()

const {
  handleClick,
} = useBtnPrimary({
  onClick: () => emit('click'),
})
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    :class="['ui-btn-primary', color, elementWidth]"
    :title="title"
    :disabled="to ? undefined : disabled"
    @click="handleClick"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <span class="ui-btn-primary__text">
      {{ text }}
    </span>
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </component>
</template>

<style lang="scss" scoped src="../styles/_btn-primary.scss" />
